export enum EViewType {
  CONSUMED = "CONSUMED",
  MANUALLY_SCHEDULED = "MANUALLY_SCHEDULED",
  SEMI_AUTOMATICALLY_SCHEDULED = "SEMI_AUTOMATICALLY_SCHEDULED",
  AUTOMATICALLY_SCHEDULED = "AUTOMATICALLY_SCHEDULED",
}
